<template lang="html">
  <v-container class="fill-height d-flex justify-center align-center" fluid>
    <v-card class="justify-center ma-12" flat tile>
      <v-theme-provider>
        <div class="text-center">
          <v-avatar color="error" size="70">
            <v-icon color="white" large>fas fa-times</v-icon>
          </v-avatar>
        </div>
      </v-theme-provider>
      <v-card-title class="heading-h1">
        Whoops, something went wrong there.
      </v-card-title>
      <v-card-text class="d-flex justify-center">
        <router-link :to="{ name: 'Home' }">Go back to home page</router-link>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: "ServerError",
  };
</script>



// WEBPACK FOOTER //
// src/components/Errors/ServerError.vue